import type { Address } from 'react-daum-postcode'

import { ApiError } from '@/types/api'

/**
 * Daum 응답에서 백엔드용 지번 주소 추출.
 * jibunAddress 우선, 없으면 autoJibunAddress(도로명 검색 시 라이브러리가 자동 매핑한 지번).
 */
export const resolveAddressJibun = (address: Address | null): string =>
  address?.jibunAddress || address?.autoJibunAddress || ''

/**
 * query 의 jibunAddress 만 채운 가짜 Address 객체 생성.
 *
 * 백엔드 1차 검증(`/orders/availability`) / waitlist 신청은 jibunAddress 만 사용.
 * Daum 결과처럼 보이도록 Address 인터페이스 모든 필드 빈 문자열로 채움.
 */
export const buildSharedAddress = (jibunAddress: string): Address => ({
  zonecode: '',
  address: jibunAddress,
  addressEnglish: '',
  addressType: 'J',
  userSelectedType: 'J',
  noSelected: 'N',
  userLanguageType: 'K',
  roadAddress: '',
  roadAddressEnglish: '',
  jibunAddress,
  jibunAddressEnglish: '',
  autoRoadAddress: '',
  autoRoadAddressEnglish: '',
  autoJibunAddress: '',
  autoJibunAddressEnglish: '',
  buildingCode: '',
  buildingName: '',
  apartment: 'N',
  sido: '',
  sidoEnglish: '',
  sigungu: '',
  sigunguEnglish: '',
  sigunguCode: '',
  roadnameCode: '',
  bcode: '',
  roadname: '',
  roadnameEnglish: '',
  bname: '',
  bnameEnglish: '',
  bname1: '',
  bname1English: '',
  bname2: '',
  bname2English: '',
  hname: '',
  query: '',
})

/**
 * bridge `onError` 페이로드 — 백엔드 envelope 응답 그대로 전달.
 *
 * ApiError 는 인터셉터에서 envelope 필드를 모두 보존하므로 reconstruct.
 * NETWORK / timeout 등 envelope 부재 케이스는 동일 구조로 fill (Flutter 측 일관 처리).
 */
export const toErrorPayload = (error: unknown) => {
  if (error instanceof ApiError) {
    return {
      txid: error.txid,
      status: error.status,
      message: error.message,
      error: {
        code: error.code,
        description: error.description,
      },
    }
  }
  return {
    txid: '',
    status: 0,
    message: error instanceof Error ? error.message : 'unknown',
    error: { code: 'NETWORK_ERROR', description: null },
  }
}
